import { Link, useNavigate } from 'react-router-dom';

export default function ProjectNavbar() {
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            <span className="text-sm font-medium whitespace-nowrap">뒤로가기</span>
          </button>

          <Link to="/" className="absolute left-1/2 -translate-x-1/2 flex items-center space-x-3 cursor-pointer">
            <span className="text-lg font-light tracking-wider text-gray-900">
              <span className="font-bold">P</span>.collective
            </span>
          </Link>

          <div className="flex items-center gap-8">
            <Link
              to="/"
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              홈
            </Link>
            <Link
              to="/gallery"
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              갤러리
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
